import * as React from 'react';
import { Info } from 'phosphor-react';
import styles from './kycIntro.module.scss';
import { WidgetStore } from '../../../../stores/widgetStore';

export interface KycIntroWidgetProps {
  onContinue(): void;
  onFinished(): void;
  widgetStore: WidgetStore;
}

// Web KYC intro sub-state of the Eligible widget (epic b.ii.2, US-01/US-02,
// story b.ii.2.4). Shown on web only when the KYC gate (story b.ii.2.3) routes
// the borrower into the KYC flow. On mobile the borrower is taken straight to
// the form, so this intro is not used there. "Continue" asks the HR dashboard
// to open the KYC form in its own modal (story b.ii.2.5).
//
// Copy and chrome follow the WebFlow intro frame, which is the consentAgreement
// widget's card: blue Info icon on the title, green links, and a compact green
// button floated right under the footer rule.
export class KycIntroWidget extends React.Component<KycIntroWidgetProps> {
  constructor(props: KycIntroWidgetProps) {
    super(props);
    this.props.widgetStore.setMenuVisibility(true);
  }

  componentDidMount() {
    // Hide the widget loading spinner + fire the view event, matching the
    // other Eligible-path widgets.
    this.props.onFinished();
  }

  render() {
    return (
      <div className={styles.widget}>
        <div className={styles.content}>
          <p className={styles.title}>
            <Info className={styles.icon} size={24} weight="fill" />
            Verify your details to unlock ReadyCash
          </p>
          <p className={styles.bodyText}>
            The form takes about 3 minutes and covers your address, ID, and work info. See
            our{' '}
            <a
              className={styles.link}
              href="https://sprout.ph/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>{' '}
            for what we share.
          </p>
          <p className={styles.bodyText}>
            If you have any concerns, feel free to contact{' '}
            <a className={styles.link} href="mailto:experts@sprout.ph">
              experts@sprout.ph
            </a>
            .
          </p>
        </div>
        <div className={styles.footer}>
          <button
            type="button"
            className={`${styles.button} primaryBtn`}
            onClick={this.props.onContinue}
          >
            <span>Continue</span>
          </button>
        </div>
      </div>
    );
  }
}

export default KycIntroWidget;
